/**
 * Manage Profile
 */

// Vendors
import $ from 'jquery';
import toggles from '../framework/toggle';

const hash = window.location.hash;
if (hash) {
  const tab = window.location.hash.substring(1);
  $('[data-toggle-switch="' + tab + '"]').trigger('toggle:show');
  $('[data-toggle-target="' + tab + '"]').trigger('toggle:show');
}

$('[data-toggle-target="tab-billing"]').on('toggle:afterShow', (event) => {
  $('.tabs__content').addClass('tabs__content--max-100');
});

$('[data-toggle-target="tab-billing"]').on('toggle:beforeHide', (event) => {
  $('.tabs__content').removeClass('tabs__content--max-100');
});
